export default {
  yes: { id: 'yes' },
  no: { id: 'no' },
}
